import { useController, UseControllerProps, FieldValues } from 'react-hook-form';
import { Checkbox, CheckboxProps } from 'shared/ui/controls/checkbox';

export type CheckBoxFieldAltProps<T extends FieldValues> = UseControllerProps<T> &
  CheckboxProps & {
    onChange?: (checked: boolean) => void;
  };

export const CheckBoxAltField = <T extends FieldValues>(props: CheckBoxFieldAltProps<T>) => {
  const { field } = useController(props);

  const { value, onChange: fieldOnChange, ...rest } = field;

  const handleChange = (checked: boolean) => {
    fieldOnChange(checked);
    props.onChange?.(checked);
  };

  return <Checkbox checked={value ?? false} onChange={handleChange} disabled={props.disabled} {...rest} />;
};
